export const link =
  'border-none hover:underline text-foreground font-semibold underline underline-offset-[3px] whitespace-nowrap';
